import Cookies from "js-cookie";
import Glide from '@glidejs/glide';

class CountryListNav {
    constructor () {
        this.hiddenClass = 'box-model--hidden';
        //this.menulist = document.querySelectorAll('.countries_nav-home > li > a[data-iso]');
        this.eventsContent = document.querySelectorAll('.country-event');
        this.countryContent = document.querySelectorAll('.country-event > div[data-country]');
        this.countryMobImg = document.querySelectorAll('[data-country-mob]');
        this.mobImages = document.querySelectorAll('.home-mob-imgs');
        this.deskBgImages = document.querySelectorAll('.bg-home-img');
        this.defaultCountry = 'ES';

        //hide all mobile images
        this.hideAllMobImages();

        //hidel all desktop bg images
        this.hideAllDskBgImages();

        /*if (this.menulist != null) {
            [...this.menulist].forEach(a => {
                a.addEventListener('click', (e)=>{
                    e.preventDefault();
                    this.resetAllActiveLinks();
                    e.currentTarget.parentNode.classList.add('active');
                    e.currentTarget.classList.add('active');
                    this.homePageFilterOptions(e.currentTarget.dataset.iso);
                    Cookies.set("selectedCountry", e.currentTarget.dataset.iso);
                });
            });

        }*/
        // show default country
        this.currentCountry(this.countryContent, this.countryMobImg,  this.deskBgImages);
    }

//  removes the active class from the li
    resetAllActiveLinks(){
        [...this.menulist].forEach(li => {
            li.classList.remove('active');
            li.parentNode.classList.remove('active');
        });
    }


    // filter each option from dropdown and show its content
    homePageFilterOptions(filterSelection) {
        filterSelection = ((typeof filterSelection) === 'object') ? filterSelection.val : filterSelection;

        //get content based on country
        this.element = document.querySelectorAll('[data-country="' + filterSelection + '"]');

        //get anchor tag from menu list in desktop
        this.listElementToShow = document.querySelector('[data-iso="' + filterSelection + '"]');

        this.glideElement = document.querySelectorAll('[data-glide-country="' + filterSelection + '"]');

        // get mobile bg images per country
        this.mobImgToShow = document.querySelector('[data-country-mob="' + filterSelection + '"]');

        // get desktop page bg images per country
        this.dskBgImgToShow = document.querySelector('[data-bg-img-match="' + filterSelection + '"]');

        //update the dropdown selected country
        this.dropdownText = document.querySelector('.dropdown-countries > .dropdown__text');


        this.hideAllEvents();
        this.hideAllMobImages();
        this.hideAllDskBgImages();
        //this.resetAllActiveLinks();
        if (this.element != null) {
            [...this.element].forEach(el => {
                //console.log(el.parentNode.classList);
                el.parentNode.classList.remove(this.hiddenClass);
                this.initGlideCarousel();
            });

            //add active class to the clicked option
            /*if (this.listElementToShow != null) {
                this.listElementToShow.parentNode.classList.add('active');
            }*/

            //show only one mob image based on option
            if (this.mobImgToShow != null) {
                this.mobImgToShow.classList.remove('hide');
            }

            //show only one desktop bg image based on option
            if (this.dskBgImgToShow != null) {
                this.dskBgImgToShow.classList.remove('hide');
            }

            //update dropdown selection based on selection from desktop menu
            //this.dropdownText.innerText = this.listElementToShow.innerHTML;
        }

    }

    hideAllEvents () {
        if (this.eventsContent != null) {
            [...this.eventsContent].forEach( content => {
                content.classList.add(this.hiddenClass);
            });
        }
    }

    hideAllMobImages() {
        if (this.mobImages != null) {
            [...this.mobImages].forEach( img => {
                img.classList.add('hide');
            });
        }
    }

    hideAllDskBgImages() {
        if (this.deskBgImages != null) {
            [...this.deskBgImages].forEach( img => {
                img.classList.add('hide');
            });
        }
    }


    initGlideCarousel () {
        this.initSliders = document.querySelectorAll('.single-slide');

        if (this.initSliders != null) {
        [...this.initSliders].forEach(sel => {
            this.glide = new Glide(sel, {
                type: 'slider',
                autoplay: 3000,
                hoverpause: false,
                perView: 1,
                })
                if( sel.querySelector("ul").children.length > 0 )
                    this.glide.mount();
            });
        }
    }

    //currentCountry(anchors, showContent, showMobImg, showDskBgImg){
    currentCountry(showContent, showMobImg, showDskBgImg){
        let _self = this;

        if( "undefined" !== typeof geolocation_url ) {
            // AJAX request for current location
            let xhttp = new XMLHttpRequest();

            xhttp.open('GET', geolocation_url);

            xhttp.onload = function(){

                if (xhttp.status === 200) {
                    //Cookies.set('selectedCountry', JSON.parse(xhttp.responseText).data.country);
                    var current_country = is_dev?JSON.parse(xhttp.responseText).countryCode:JSON.parse(xhttp.responseText).data.country;
                    _self.homePageFilterOptions(current_country);
                } else {
                    _self.showDefaultCountry(showContent, showMobImg, showDskBgImg);
                }

            }

            //xhttp.send(JSON.stringify({ project: "j95bw15y" }));
            var params = is_dev?{fields: "countryCode"}:{project: "j95bw15y"};
            xhttp.send(JSON.stringify(params));
        } else {
            this.homePageFilterOptions(this.defaultCountry);
            this.showDefaultCountry(showContent, showMobImg, showDskBgImg);
        }
    }

    showDefaultCountry(showContent, showMobImg, showDskBgImg){
        showContent.forEach( countryContent => {
            if ( countryContent.dataset.country === this.defaultCountry ) {
                countryContent.parentNode.classList.remove('box-model--hidden');
                countryContent.parentNode.classList.add('box-model-flex');
            } else {
                return false;
            }
        });
        showMobImg.forEach( mobImg => {
            if ( mobImg.dataset.countryMob === this.defaultCountry ) {
                mobImg.classList.remove('hide');
            } else {
                return false;
            }
        });
        showDskBgImg.forEach( bgImg => {
            if ( bgImg.dataset.countryMob === this.defaultCountry ) {
                bgImg.classList.remove('hide');
            } else {
                return false;
            }
        });
    }
}

export default CountryListNav

